import React from 'react';
import { useSelector } from 'react-redux';
import { TaskTimeChip } from './TaskTimeChip';
import { ToneBadge } from '../../../components/ui/ToneBadge';
import { selectTasksNow } from '../../../features/operatorTasks/operatorTasksSlice';
import { activityText, taskReasonText, taskTimeOf } from '../../../features/operatorTasks/operatorTasksUtils';

/**
 * Where a task stands, in one line: its time, why it goes where it goes, and
 * who is on it. Nothing when there is nothing to say.
 *
 * An order already started that ran out of stock for the rest is still
 * listed, so it says why it does not move: «Espera stock».
 *
 * @param {object} props
 * @param {object} props.task - A tray task or a queue row: both carry the same fields.
 * @param {React.ReactNode} [props.children] - Shown first, e.g. its type.
 */
export const TaskMeta = ({ task, children }) => {
  const now = useSelector(selectTasksNow);
  const reason = taskReasonText(task);
  const activity = activityText(task);
  const waitingStock = Boolean(task.waiting_stock);
  if (!children && !waitingStock && !reason && !activity && !taskTimeOf(task, now)) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {children}
      {waitingStock && (
        <ToneBadge tone="warning" testId="task-waiting-stock">
          Espera stock
        </ToneBadge>
      )}
      <TaskTimeChip task={task} />
      {reason && (
        <span data-testid="task-reason" className="text-sm font-semibold text-ninja-dark dark:text-white">
          {reason}
        </span>
      )}
      {activity && (
        <span data-testid="task-activity" className="text-sm text-text-secondary">
          {activity}
        </span>
      )}
    </div>
  );
};
